import { put, call, all, takeLatest } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';
import { modal } from '../../components/Base/Modal';

export function* getChatModerators({ payload }) {
  try {
    const { data, status } = yield call(api.chat.getChatModerators, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_CHAT_MODERATORS_SUCCESS, payload: data });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.GET_CHAT_MODERATORS_FAILURE });
  }
}

export function* postChatModerator({ payload }) {
  try {
    const { data, status } = yield call(api.chat.postChatModerator, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_CHAT_MODERATOR_SUCCESS, payload: data });

    modal.close();
  } catch (e) {
    yield put({ type: types.POST_CHAT_MODERATOR_FAILURE });
    if (
      e?.response?.data?.errors?.email &&
      e?.response?.data?.errors?.email?.includes('the_selected_email_is_invalid')
    ) {
      notification({
        type: 'error',
        message: 'The selected email is invalid.',
      });
    }
    if (
      e?.response?.data?.errors?.nick_name &&
      e?.response?.data?.errors?.nick_name?.includes(
        'the_nick_name_must_be_at_least5_characters',
      )
    ) {
      notification({
        type: 'error',
        message: 'The nick name must be at least 5 characters.',
      });
    }
    if (
      e?.response?.data?.errors?.nick_name &&
      e?.response?.data?.errors?.nick_name?.includes(
        'the_nick_name_has_already_been_taken',
      )
    ) {
      notification({
        type: 'error',
        message: 'The nick name has already been taken.',
      });
    }
  }
}

export function* putChatModeratorRole({ payload }) {
  try {
    const { data, status } = yield call(api.chat.putChatModeratorRole, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.PUT_CHAT_MODERATOR_ROLE_SUCCESS,
      payload: payload.user_id,
    });
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.PUT_CHAT_MODERATOR_ROLE_FAILURE });
  }
}

export function* chatModerators() {
  yield all([
    yield takeLatest(types.GET_CHAT_MODERATORS_START, getChatModerators),
    yield takeLatest(types.POST_CHAT_MODERATOR_START, postChatModerator),
    yield takeLatest(types.PUT_CHAT_MODERATOR_ROLE_START, putChatModeratorRole),
  ]);
}
